export enum NotificationType {
    AUCUNE = 'AUCUNE',
    EMAIL = 'EMAIL'
}

export interface Contact {
    numeroFixe?: string;
    numeroPortable?: string;
}

export interface Address {
    adresse1: string;
    adresse2?: string;
    adresse3?: string;
    codePostal: string;
    ville: string;
    pays: string;
}

/** IHM - display */
export interface Account {
    id: number;
    franceConnectSubscription?: string;
    email: string;
    type: AccountType;
    fonctionEntreprise?: string;
    nomEntreprise?: string;
    sigleEntreprise?: string;
    civilite: string;
    firstName: string;
    lastName: string;
    address: Address;
    contact: Contact;
}

export interface Credentials {
    email: string;
    oldEmail?: string;
    password?: string;
    oldPassword?: string;
    franceConnectSubscription?: string;
}

/** IHM - register + update */
export class EditableAccount {
    id?: number;
    civilite?: string;
    firstName?: string;
    lastName?: string;
    birthDate?: Date;
    fonctionEntreprise?: string;
    nomEntreprise?: string;
    sigleEntreprise?: string;
    credentials: Credentials = {} as Credentials;
    address: Address = {} as Address;
    contact: Contact = {} as Contact;
    notification: NotificationType = NotificationType.EMAIL;
    type: AccountType;
    captcha?: string;

    toAccountDTO(): EditableAccountDTO {
        return Object.assign({},
            {
                id: this.id,
                type: this.type,
                civilite: this.civilite,
                firstName: this.firstName,
                lastName: this.lastName,
                birthDate: this.birthDate,
                fonctionEntreprise: this.fonctionEntreprise,
                nomEntreprise: this.nomEntreprise,
                sigleEntreprise: this.sigleEntreprise,
                notification: this.notification,
                captcha: this.captcha,
                address: this.address,
                contact: this.contact
            },
            this.credentials
        );
    }
}

export class MyInformation {
    firstName?: string;
    lastName?: string;
    adresse1: string;
    adresse2?: string;
    adresse3?: string;
    codePostal: string;
    ville: string;
    pays: string;
    email: string;
}

/** Backend : Register / Update */
export interface EditableAccountDTO extends Account {
    oldEmail?: string;
    password?: string;
    newPassword?: string;
    oldPassword?: string;
    birthDate: Date;
    notification: NotificationType;
    versionCgu?: string;
    dateAcceptationCgu?: string;
    captcha?: string;
    userClubMember?: boolean;
}

export enum UpdateAccountErrorType {
    EMAIL_ALREADY_IN_USE = '1031',
    WRONG_OLD_PASSWORD = '1033'
}

export enum CreateAccountErrorType {
    EMAIL_ALREADY_IN_USE = '1031',
    INVALID_PASSWORD = '1034',
    INVALID_NEW_PASSWORD = '1035'
}

export enum AccountType {
    PHYSIQUE = 'PHYSIQUE',
    MORALE = 'MORALE'
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/model/account.model.ts